// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingBox_container__3MmJ8","loadingLight":"LoadingBox_loadingLight__e_W6c","loadingDark":"LoadingBox_loadingDark__1B9Sc"};